import { FC } from "react";
import { CXWorkspaceAdminLayout } from "../CXWorkspaceAdminLayout";
import { CXPlansPage } from "../CXPlansPage";

export const CXWorkspacePlansPage: FC = () => (
  <CXWorkspaceAdminLayout>
    <CXPlansPage />
  </CXWorkspaceAdminLayout>
);
